import * as react from 'react';
import { useEffect } from 'react';
export interface MailTempPreviewProp {
    temp: any
}


export const MailTempPreview = (props: any) => {

    const handleTemp = () => {
        let modifiedTemp = props.temp || '';

        const replacements: Record<string, string> = {
            '#empName#': 'Gourav',
            '#emailId#': 'gourav@gmail.com',
            '#password#': '********',
        };

        Object.entries(replacements).forEach(([placeholder, value]) => {
            modifiedTemp = modifiedTemp.split(placeholder).join(value);
        });

        return modifiedTemp;
    }

    const modifiedTemp = handleTemp();



    const theObj = { __html: modifiedTemp };

    return <div style={{ paddingBottom: '1rem' }} dangerouslySetInnerHTML={theObj} />;
}